module.exports = __webpack_public_path__ + "img/ic_zhjx_student.704df3aa.png";